module.exports = __webpack_public_path__ + "img/team-3.1caa3e94.jpg";